// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"584":"9c9a76df","722":"5757ddf1","809":"6675e8a0"}[chunkId] + ".chunk.js";
};